export enum ValidationState {
  /** Validation hasn't run */
  INITIAL = 0,
  /** Validation is in progress */
  LOADING = 1,
  /** Validation has run without violations */
  VALID = 2,
  /** Validation has run but found violations */
  WARNING = 3,
  /** Something out of our control prevented the validation from running */
  FAILED = 4,
}
